import { render, staticRenderFns } from "./s-intro-small.vue?vue&type=template&id=0ed8d314&"
import script from "./s-intro-small.vue?vue&type=script&lang=js&"
export * from "./s-intro-small.vue?vue&type=script&lang=js&"
import style0 from "./s-intro-small.vue?vue&type=style&index=0&id=0ed8d314&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports